import { render } from "./step5.vue?vue&type=template&id=7b2a2b5e&scoped=true"
import script from "./step5.vue?vue&type=script&lang=js"
export * from "./step5.vue?vue&type=script&lang=js"

import "./step5.vue?vue&type=style&index=0&id=7b2a2b5e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b2a2b5e"]])

export default __exports__